import { structureActions, structureMobileData } from '@redux/slices/structure/structure-slice';
import { checkOldAndNewArray } from '@services/check-old-and-new-array';
import { getAppDispatch } from '@utilities/dispatch.util';
import { store } from 'redux/store';

const structureJsonManipulationJson = ({ initialLogin, data, isSettingUpdated }) => {
  const { structure } = store.getState();

  let resStructure = [];
  const { items = [] } = data;
  if (!initialLogin && items?.length && structure?.structureMobile?.length && !isSettingUpdated) {
    const combineNewAndOldArray = checkOldAndNewArray({
      oldArray: structure?.structureMobile,
      oldArrayMap: structure?.structureMobileMap,
      newArray: items,
      idName: 'structureId'
    });
    resStructure = combineNewAndOldArray;
  } else {
    if (items?.length) {
      resStructure = items;
    }
  }

  const { structures, structuresMap, sitesStructureMap } = structureMobileData(resStructure || []);
  const structureMobile = resStructure;
  const sitesStructuresMap = sitesStructureMap;
  const structureMobileMap = structureMobile.reduce((acc, curr, currIndex) => {
    acc[curr.structureId] = currIndex;
    return acc;
  }, {});

  return {
    structureMobile,
    structure: structures,
    sitesStructuresMap,
    structureMobileMap,
    structuresMap
  };
};

const structureDispatcher = ({ data }) => {
  const dispatch = getAppDispatch();

  dispatch?.(structureActions.setStructureMobile(data));
};

export { structureJsonManipulationJson, structureDispatcher };
